import { Component, Inject, OnDestroy, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material';
import { AppConfig } from '@config/app.config';
import { GeneralsService } from '@core/services/generals.service';
import { Constants } from '@shared/class/constants.class';
import { Customer } from '@shared/interfaces/customer';

@Component({
  selector: 'app-customers-list',
  templateUrl: './customers-list.component.html'
})
export class CustomersListComponent implements OnInit, OnDestroy {
  public constants = new Constants();

  public customer: Customer;

  constructor(
    public appConfig: AppConfig,
    public dialogRef: MatDialogRef<CustomersListComponent>,
    public generalsService: GeneralsService,
    @Inject(MAT_DIALOG_DATA) private data
  ) {}

  ngOnInit() {
    this.constants.title = this.appConfig.LANG.customers.details;
    this.constants.elements = true;
    if (Object.keys(this.data).length > 0) {
      this.customer = {
        id: this.data.id,
        idTypeIdentify: this.data.attributes.documentType,
        typeIdentify: this.data.attributes.documentTypeName,
        identify: this.data.attributes.documentNumber,
        name: this.data.attributes.customerName,
        segment: '',
        dead: false,
        monthlyValue: this.data.attributes.monthlyValue,
        annualValue: this.data.attributes.annualValue,
        monthlyCount: this.data.attributes.monthlyCount,
        annualCount: this.data.attributes.annualCount
      };
    } else {
      this.constants.elements = false;
    }
  }

  ngOnDestroy() {
    this.constants.destroy$.next(true);
    this.constants.destroy$.unsubscribe();
  }

  close() {
    this.dialogRef.close(300);
  }
}
